<template>
  <div class="round-button-with-icon">
    <svg
      v-if="icon === 'wand'"
      width="29"
      height="26"
      viewBox="0 0 29 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.4579 13.0454V19.0454"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.4579 16.0454H27.4579"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.95792 2.04541V7.04541"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.45792 4.54541H10.4579"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.4579 20.0454V24.0454"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4579 22.0454H20.4579"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.7612 1.74938L2.17314 20.3374C1.78262 20.728 1.78262 21.3611 2.17314 21.7517L4.7585 24.337C5.14902 24.7275 5.78219 24.7275 6.17271 24.337L24.7608 5.74895C25.1513 5.35843 25.1513 4.72526 24.7608 4.33474L22.1754 1.74938C21.7849 1.35886 21.1517 1.35886 20.7612 1.74938Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.4579 7.04541L19.4579 11.0454"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="icon === 'contract'"
      width="32"
      height="29"
      viewBox="0 0 32 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 27.9543V2.84506C1 2.51209 1.1317 2.19276 1.36612 1.95732C1.60054 1.72187 1.91848 1.5896 2.25 1.5896H29.75C30.0815 1.5896 30.3995 1.72187 30.6339 1.95732C30.8683 2.19276 31 2.51209 31 2.84506V27.9543L26 25.4434L21 27.9543L16 25.4434L11 27.9543L6 25.4434L1 27.9543Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5 11.6333H26"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5 16.6552H26"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.03125 13.1273C6.03125 13.1273 7.40625 11.1938 9.46875 11.1938C13.9375 11.1938 13.5938 18.0989 9.46875 18.0989C6.71875 18.0989 6.71875 13.9559 10.8438 13.9559C13.5938 13.9559 15.3125 16.0274 15.3125 16.0274"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'play'"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.5125 15.15L10.525 4.15C10.3736 4.05659 10.2 4.00528 10.0221 4.00134C9.84424 3.99741 9.66854 4.041 9.51314 4.12762C9.35774 4.21424 9.22826 4.34075 9.13805 4.4941C9.04785 4.64745 9.0002 4.82208 9 5V27C9.0002 27.1779 9.04785 27.3525 9.13805 27.5059C9.22826 27.6592 9.35774 27.7858 9.51314 27.8724C9.66854 27.959 9.84424 28.0026 10.0221 27.9986C10.2 27.9947 10.3736 27.9434 10.525 27.85L28.5125 16.85C28.6602 16.7627 28.7826 16.6383 28.8676 16.4893C28.9526 16.3402 28.9974 16.1716 28.9974 16C28.9974 15.8284 28.9526 15.6598 28.8676 15.5107C28.7826 15.3617 28.6602 15.2373 28.5125 15.15V15.15Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="icon === 'pause'"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7505 28.9817C23.3779 28.9817 28.7505 23.6091 28.7505 16.9817C28.7505 10.3543 23.3779 4.98169 16.7505 4.98169C10.1231 4.98169 4.75049 10.3543 4.75049 16.9817C4.75049 23.6091 10.1231 28.9817 16.7505 28.9817Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M13.7505 12.9817V20.9817"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.7505 12.9817V20.9817"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="icon === 'forms'"
      width="33"
      height="26"
      viewBox="0 0 33 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.01611 1.86884H31.1125V23.2803C31.1125 23.6143 30.9804 23.9347 30.7452 24.1709C30.51 24.4071 30.191 24.5398 29.8585 24.5398H2.27013C1.93754 24.5398 1.61858 24.4071 1.38341 24.1709C1.14823 23.9347 1.01611 23.6143 1.01611 23.2803V1.86884Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.01611 9.42584H31.1125"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.01611 16.9828H31.1125"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.79395 9.42584V24.5398"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'invoice'"
      width="32"
      height="29"
      viewBox="0 0 32 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 27.9543V2.84506C1 2.51209 1.1317 2.19276 1.36612 1.95732C1.60054 1.72187 1.91848 1.5896 2.25 1.5896H29.75C30.0815 1.5896 30.3995 1.72187 30.6339 1.95732C30.8683 2.19276 31 2.51209 31 2.84506V27.9543L26 25.4434L21 27.9543L16 25.4434L11 27.9543L6 25.4434L1 27.9543Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5 11.6333H26"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5 16.6552H26"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.54199 9.40216V19.6028"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.2764 12.5407C12.2764 12.2831 12.2258 12.028 12.1277 11.79C12.0295 11.552 11.8857 11.3358 11.7043 11.1536C11.5229 10.9714 11.3076 10.8269 11.0707 10.7284C10.8337 10.6298 10.5797 10.579 10.3232 10.579H8.56543C8.04743 10.579 7.55064 10.7857 7.18436 11.1536C6.81808 11.5215 6.6123 12.0204 6.6123 12.5407C6.6123 13.061 6.81808 13.5599 7.18436 13.9278C7.55064 14.2957 8.04743 14.5024 8.56543 14.5024H10.7139C11.2319 14.5024 11.7287 14.709 12.0949 15.0769C12.4612 15.4448 12.667 15.9438 12.667 16.464C12.667 16.9843 12.4612 17.4832 12.0949 17.8511C11.7287 18.219 11.2319 18.4257 10.7139 18.4257H8.37012C7.85212 18.4257 7.35533 18.219 6.98905 17.8511C6.62277 17.4832 6.41699 16.9843 6.41699 16.464"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'plane'"
      width="47"
      height="47"
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.7875 11.9875L10.4875 18.55C10.2892 18.6042 10.1124 18.7183 9.98117 18.8766C9.84999 19.035 9.7708 19.2299 9.75441 19.4349C9.73801 19.6398 9.78519 19.8449 9.88953 20.0221C9.99388 20.1992 10.1503 20.34 10.3375 20.425L21.0375 25.4875C21.2471 25.5846 21.4154 25.7529 21.5125 25.9625L26.575 36.6625C26.6601 36.8497 26.8008 37.0061 26.978 37.1105C27.1551 37.2148 27.3602 37.262 27.5651 37.2456C27.7701 37.2292 27.965 37.15 28.1234 37.0188C28.2817 36.8877 28.3958 36.7109 28.45 36.5125L35.0125 13.2125C35.0622 13.0425 35.0653 12.8622 35.0214 12.6906C34.9775 12.519 34.8882 12.3623 34.763 12.237C34.6377 12.1118 34.4811 12.0225 34.3094 11.9786C34.1378 11.9347 33.9575 11.9378 33.7875 11.9875V11.9875Z"
        stroke="#575757"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.3625 25.6375L27.0125 19.9875"
        stroke="#575757"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="icon === 'x'"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8986 5.0116L5.0116 17.8986"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.8986 17.8986L5.0116 5.0116"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'eye-open'"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 5.03125C4.3125 5.03125 1.4375 11.5 1.4375 11.5C1.4375 11.5 4.3125 17.9688 11.5 17.9688C18.6875 17.9688 21.5625 11.5 21.5625 11.5C21.5625 11.5 18.6875 5.03125 11.5 5.03125Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.5 15.0938C13.4848 15.0938 15.0938 13.4848 15.0938 11.5C15.0938 9.51523 13.4848 7.90625 11.5 7.90625C9.51523 7.90625 7.90625 9.51523 7.90625 11.5C7.90625 13.4848 9.51523 15.0938 11.5 15.0938Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'pencil'"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.77696 22.7813H5.06251C4.83873 22.7813 4.62412 22.6924 4.46588 22.5341C4.30765 22.3759 4.21876 22.1613 4.21876 21.9375V17.2231C4.21837 17.1135 4.2396 17.005 4.28122 16.9036C4.32285 16.8023 4.38405 16.7101 4.46133 16.6325L17.1176 3.9762C17.1961 3.89648 17.2897 3.83317 17.3929 3.78996C17.4961 3.74674 17.6069 3.72449 17.7188 3.72449C17.8306 3.72449 17.9414 3.74674 18.0446 3.78996C18.1478 3.83317 18.2414 3.89648 18.3199 3.9762L23.0238 8.68011C23.1036 8.75862 23.1669 8.8522 23.2101 8.95541C23.2533 9.05862 23.2755 9.16939 23.2755 9.28128C23.2755 9.39317 23.2533 9.50394 23.2101 9.60715C23.1669 9.71036 23.1036 9.80394 23.0238 9.88245L10.3676 22.5387C10.2899 22.616 10.1978 22.6772 10.0964 22.7188C9.99508 22.7604 9.88652 22.7817 9.77696 22.7813V22.7813Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.3438 6.75L20.25 12.6562"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'plus'"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.21875 13.5H22.7812"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5 4.21875V22.7812"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      v-if="icon === 'print'"
      width="33"
      height="33"
      viewBox="0 0 33 33"
    >
      <g
        id="Icon_feather-printer"
        data-name="Icon feather-printer"
        transform="translate(-1.5 -1.5)"
      >
        <path
          id="Path_194"
          data-name="Path 194"
          d="M9,13.5V3H27V13.5"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
        />
        <path
          id="Path_195"
          data-name="Path 195"
          d="M9,27H6a3,3,0,0,1-3-3V16.5a3,3,0,0,1,3-3H30a3,3,0,0,1,3,3V24a3,3,0,0,1-3,3H27"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
        />
        <path
          id="Path_196"
          data-name="Path 196"
          d="M9,21H27V33H9Z"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
        />
      </g>
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42.783"
      height="35.872"
      viewBox="0 0 42.783 35.872"
      v-if="icon === 'checked-signature'"
    >
      <path
        id="Icon_awesome-signature"
        data-name="Icon awesome-signature"
        d="M32.461,13.5c-2.7.246-6.547,3.846-8.5,5.027-1.516.921-2.823,1.716-3.964,1.716-1.177,0-1.354-1.139-1.109-3.649.057-.562.609-5.569-2.224-5.351-1.307.105-3.349,1.744-8.829,8.859L10,12.811C11.585,7.474,7.23,2.159,3.246,5.583L.386,8.177A1.385,1.385,0,0,0,.131,9.731l.9,1.9a.715.715,0,0,0,1.151.345L5.2,9.239c.958-.823,2.12.506,1.7,1.905L1.787,28.413C1.433,29.6,1.928,31.5,3.334,31.5a1.47,1.47,0,0,0,1.177-.661c2.2-2.967,8.058-10.6,11-13.767-.115,2-.109,4.141,1.073,5.892A3.888,3.888,0,0,0,20,24.743c1.854,0,3.542-1.027,5.328-2.109,1.719-1.041,5.157-4.4,7.209-4.627a1.034,1.034,0,0,0,.792-1.111V14.639c.01-.64-.391-1.181-.865-1.139Z"
        transform="translate(-0.002 4.372)"
      />
      <path
        id="Icon_feather-check"
        data-name="Icon feather-check"
        d="M30,9,13.5,25.5,6,18"
        transform="translate(10.662 -6.879)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34.377"
      height="30.832"
      viewBox="0 0 34.377 30.832"
      v-if="icon === 'signature-admin'"
    >
      <g
        id="Path_200"
        data-name="Path 200"
        transform="translate(4.148 -9.008)"
        fill="none"
      >
        <path
          d="M13.079,9.008c6.97,5.556,13.085-3.973,13.085,3.254V23.673c0,7.227-9.223,16.136-13.085,16.166S-.006,30.9-.006,23.673V14.95c0-.354-.052-2.128,0-2.688C.068,5.558,6.286,14.568,13.079,9.008Z"
          stroke="none"
        />
        <path
          d="M 13.11068630218506 13.72640228271484 C 11.49751091003418 14.52123069763184 9.77174186706543 14.92217254638672 7.952688217163086 14.92217254638672 C 6.461776733398438 14.92217254638672 5.116870880126953 14.6534366607666 3.98533821105957 14.35475730895996 C 3.985662460327148 14.37273406982422 3.985967636108398 14.38948249816895 3.986248016357422 14.40493202209473 C 3.990877151489258 14.65917205810547 3.993927001953125 14.82713317871094 3.993927001953125 14.94954299926758 L 3.993927001953125 23.67316246032715 C 3.993927001953125 25.72980308532715 5.422847747802734 28.69475173950195 7.723058700561523 31.41097259521484 C 8.786218643188477 32.66641998291016 10.00118827819824 33.82499313354492 11.14413833618164 34.67326354980469 C 12.08422374725342 35.37097930908203 12.74451923370361 35.68791198730469 13.05873680114746 35.80177307128906 C 13.37430095672607 35.68743133544922 14.03744411468506 35.36965942382812 14.98221778869629 34.67116165161133 C 16.13054656982422 33.82216262817383 17.35076904296875 32.66415405273438 18.41809844970703 31.41045188903809 C 20.76416778564453 28.65473175048828 22.16479873657227 25.76228141784668 22.16479873657227 23.67316246032715 L 22.16479873657227 14.21738052368164 C 20.99811744689941 14.54951477050781 19.61433410644531 14.84369277954102 18.06884765625 14.84369277954102 C 16.33056640625 14.84369277954102 14.67156982421875 14.46897506713867 13.11068630218506 13.72640228271484 M 13.07936763763428 9.0078125 C 17.93932342529297 12.8815803527832 22.38388633728027 9.421501159667969 24.62946319580078 9.421394348144531 C 25.60443305969238 9.421352386474609 26.16479873657227 10.07353591918945 26.16479873657227 12.2613639831543 L 26.16479873657227 23.67316246032715 C 26.16479873657227 30.90004348754883 16.94221878051758 39.80961227416992 13.07936763763428 39.83943176269531 C 9.216304779052734 39.86922454833984 -0.006072998046875 30.9000415802002 -0.006072998046875 23.67316246032715 L -0.006072998046875 14.94954299926758 C -0.006072998046875 14.59542274475098 -0.05840301513671875 12.82110214233398 -0.006072998046875 12.2613639831543 C 0.04863739013671875 7.316436767578125 3.446792602539062 10.92216873168945 7.952688217163086 10.92216873168945 C 9.555065155029297 10.92216873168945 11.29724788665771 10.46634292602539 13.07936763763428 9.0078125 Z"
          stroke="none"
          fill="currentColor"
        />
      </g>
      <path
        id="Icon_awesome-signature"
        data-name="Icon awesome-signature"
        d="M32.461,13.5c-2.7.246-6.547,3.846-8.5,5.027-1.516.921-2.823,1.716-3.964,1.716-1.177,0-1.354-1.139-1.109-3.649.057-.562.609-5.569-2.224-5.351-1.307.105-3.349,1.744-8.829,8.859L10,12.811C11.585,7.474,7.23,2.159,3.246,5.583L.386,8.177A1.385,1.385,0,0,0,.131,9.731l.9,1.9a.715.715,0,0,0,1.151.345L5.2,9.239c.958-.823,2.12.506,1.7,1.905L1.787,28.413C1.433,29.6,1.928,31.5,3.334,31.5a1.47,1.47,0,0,0,1.177-.661c2.2-2.967,8.058-10.6,11-13.767-.115,2-.109,4.141,1.073,5.892A3.888,3.888,0,0,0,20,24.743c1.854,0,3.542-1.027,5.328-2.109,1.719-1.041,5.157-4.4,7.209-4.627a1.034,1.034,0,0,0,.792-1.111V14.639c.01-.64-.391-1.181-.865-1.139Z"
        transform="translate(0.552 -2.584)"
        fill="var(--backgroundColor)"
        stroke="currentColor"
        stroke-width="1"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33.324"
      height="27.001"
      viewBox="0 0 33.324 27.001"
      v-if="icon === 'signature'"
    >
      <path
        id="Icon_awesome-signature"
        data-name="Icon awesome-signature"
        d="M32.461,13.5c-2.7.246-6.547,3.846-8.5,5.027-1.516.921-2.823,1.716-3.964,1.716-1.177,0-1.354-1.139-1.109-3.649.057-.562.609-5.569-2.224-5.351-1.307.105-3.349,1.744-8.829,8.859L10,12.811C11.585,7.474,7.23,2.159,3.246,5.583L.386,8.177A1.385,1.385,0,0,0,.131,9.731l.9,1.9a.715.715,0,0,0,1.151.345L5.2,9.239c.958-.823,2.12.506,1.7,1.905L1.787,28.413C1.433,29.6,1.928,31.5,3.334,31.5a1.47,1.47,0,0,0,1.177-.661c2.2-2.967,8.058-10.6,11-13.767-.115,2-.109,4.141,1.073,5.892A3.888,3.888,0,0,0,20,24.743c1.854,0,3.542-1.027,5.328-2.109,1.719-1.041,5.157-4.4,7.209-4.627a1.034,1.034,0,0,0,.792-1.111V14.639c.01-.64-.391-1.181-.865-1.139Z"
        transform="translate(-0.002 -4.499)"
      />
    </svg>

    <svg
      v-if="icon === 'circle-checkmark'"
      xmlns="http://www.w3.org/2000/svg"
      width="13.6"
      height="13.6"
      viewBox="0 0 13.6 13.6"
    >
      <path
        fill="currentColor"
        id="Icon_awesome-check-circle"
        data-name="Icon awesome-check-circle"
        d="M13.928,7.128a6.8,6.8,0,1,1-6.8-6.8A6.8,6.8,0,0,1,13.928,7.128Zm-7.587,3.6,5.045-5.045a.439.439,0,0,0,0-.62l-.62-.62a.439.439,0,0,0-.62,0L6.031,8.557,4.11,6.636a.439.439,0,0,0-.62,0l-.62.62a.439.439,0,0,0,0,.62l2.852,2.852A.439.439,0,0,0,6.342,10.729Z"
        transform="translate(-0.328 -0.328)"
      />
    </svg>
    <svg
      v-if="icon === 'save'"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <g
        id="Icon_feather-save"
        data-name="Icon feather-save"
        transform="translate(-3 -3)"
      >
        <path
          id="Path_197"
          data-name="Path 197"
          d="M28.5,31.5H7.5a3,3,0,0,1-3-3V7.5a3,3,0,0,1,3-3H24L31.5,12V28.5A3,3,0,0,1,28.5,31.5Z"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
        />
        <path
          id="Path_198"
          data-name="Path 198"
          d="M25.5,31.5v-12h-15v12"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
        />
        <path
          id="Path_199"
          data-name="Path 199"
          d="M10.5,4.5V12h12"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
        />
      </g>
    </svg>
    <svg
      v-if="icon === 'spotify'"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.3875 10.5375C17.4079 9.52485 15.2158 8.99783 12.9922 9.00001C10.7687 9.00218 8.57756 9.53348 6.59998 10.55"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5375 14.0874C16.1297 13.3707 14.572 12.9981 12.9923 13.0003C11.4125 13.0024 9.85582 13.3793 8.45001 14.0999"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.6875 17.6375C14.8546 17.2158 13.9336 16.9974 13 17C12.0629 17.0019 11.1389 17.22 10.3 17.6375"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="icon === 'checkmark'"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.7812 7.59375L10.9688 19.4062L5.0625 13.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'eye-strike'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 3.75L19.5 20.25"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.5218 14.775C13.8336 15.4054 12.9332 15.7535 11.9999 15.75C11.243 15.7499 10.5039 15.5208 9.87966 15.0928C9.25543 14.6647 8.77533 14.0579 8.50247 13.3519C8.22961 12.6459 8.17677 11.8739 8.35089 11.1373C8.52501 10.4007 8.91794 9.73406 9.47803 9.22498"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.9375 6.43127C3.1125 8.36252 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C13.7574 18.7643 15.4929 18.3594 17.0625 17.5688"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5563 15.8531C21.6 14.025 22.5 12 22.5 12C22.5 12 19.5 5.25002 12 5.25002C11.3498 5.24874 10.7007 5.30205 10.0594 5.4094"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.7031 8.31567C13.5006 8.46678 14.2273 8.87317 14.7735 9.47353C15.3198 10.0739 15.6559 10.8356 15.7313 11.6438"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'clock'"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 22.75C18.3848 22.75 22.75 18.3848 22.75 13C22.75 7.61522 18.3848 3.25 13 3.25C7.61522 3.25 3.25 7.61522 3.25 13C3.25 18.3848 7.61522 22.75 13 22.75Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M13 7.3125V13H18.6875"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'left-arrow-single'"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.625 20.3125L7.8125 12.5L15.625 4.6875"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'right-arrow-single'"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.375 4.6875L17.1875 12.5L9.375 20.3125"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'left-arrow-double'"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.3125 21.125L12.1875 13L20.3125 4.875"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.1875 21.125L4.0625 13L12.1875 4.875"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'right-arrow-double'"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.6875 4.875L13.8125 13L5.6875 21.125"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.8125 4.875L21.9375 13L13.8125 21.125"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'search'"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7812 20.3125C16.4929 20.3125 20.3125 16.4929 20.3125 11.7812C20.3125 7.06957 16.4929 3.25 11.7812 3.25C7.06957 3.25 3.25 7.06957 3.25 11.7812C3.25 16.4929 7.06957 20.3125 11.7812 20.3125Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.8141 17.8141L22.75 22.75"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'music-note'"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.3359 21.4844C20.9971 21.4844 22.3438 20.1377 22.3438 18.4766C22.3438 16.8154 20.9971 15.4688 19.3359 15.4688C17.6748 15.4688 16.3281 16.8154 16.3281 18.4766C16.3281 20.1377 17.6748 21.4844 19.3359 21.4844Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.58594 24.9219C7.24711 24.9219 8.59375 23.5752 8.59375 21.9141C8.59375 20.2529 7.24711 18.9062 5.58594 18.9062C3.92477 18.9062 2.57812 20.2529 2.57812 21.9141C2.57812 23.5752 3.92477 24.9219 5.58594 24.9219Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.3438 8.59375L8.59375 12.0312"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.59375 21.9141V6.875L22.3438 3.4375V18.4766"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'envelope'"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.625 5.90625L13.5 15.1875L3.375 5.90625"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.375 5.90625H23.625V20.25C23.625 20.4738 23.5361 20.6884 23.3779 20.8466C23.2196 21.0049 23.005 21.0938 22.7812 21.0938H4.21875C3.99497 21.0938 3.78036 21.0049 3.62213 20.8466C3.46389 20.6884 3.375 20.4738 3.375 20.25V5.90625Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.6543 13.5L3.63867 20.8512"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.3613 20.8512L15.3457 13.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'trash-can'"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9375 5.6875H4.0625"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5625 10.5625V17.0625"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.4375 10.5625V17.0625"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.3125 5.6875V21.125C20.3125 21.3405 20.2269 21.5472 20.0745 21.6995C19.9222 21.8519 19.7155 21.9375 19.5 21.9375H6.5C6.28451 21.9375 6.07785 21.8519 5.92548 21.6995C5.7731 21.5472 5.6875 21.3405 5.6875 21.125V5.6875"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.0625 5.6875V4.0625C17.0625 3.63152 16.8913 3.2182 16.5865 2.91345C16.2818 2.6087 15.8685 2.4375 15.4375 2.4375H10.5625C10.1315 2.4375 9.7182 2.6087 9.41345 2.91345C9.10871 3.2182 8.9375 3.63152 8.9375 4.0625V5.6875"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'download'"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.73438 11.1719L13 15.4375L17.2656 11.1719"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13 4.0625V15.4375"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.9375 15.4375V21.125C21.9375 21.3405 21.8519 21.5472 21.6995 21.6995C21.5472 21.8519 21.3405 21.9375 21.125 21.9375H4.875C4.65951 21.9375 4.45285 21.8519 4.30048 21.6995C4.1481 21.5472 4.0625 21.3405 4.0625 21.125V15.4375"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="icon === 'upload'"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.73438 8.32812L13 4.0625L17.2656 8.32812"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13 15.4375V4.0625"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.9375 15.4375V21.125C21.9375 21.3405 21.8519 21.5472 21.6995 21.6995C21.5472 21.8519 21.3405 21.9375 21.125 21.9375H4.875C4.65951 21.9375 4.45285 21.8519 4.30048 21.6995C4.1481 21.5472 4.0625 21.3405 4.0625 21.125V15.4375"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'chat'"
      width="29"
      height="26"
      viewBox="0 0 29 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.26241 14.5417C1.14161 12.6633 0.748759 10.4424 1.15764 8.29614C1.56653 6.1499 2.74901 4.22601 4.48302 2.88578C6.21702 1.54554 8.38324 0.881186 10.5748 1.01748C12.7664 1.15377 14.8326 2.08133 16.3853 3.62596C17.938 5.17059 18.8705 7.22601 19.0075 9.40619C19.1445 11.5864 18.4766 13.7413 17.1294 15.4663C15.7821 17.1913 13.8482 18.3676 11.6907 18.7743C9.53323 19.1811 7.30071 18.7903 5.41241 17.6753L2.29991 18.5582C2.17167 18.5941 2.03614 18.5953 1.90726 18.5618C1.77837 18.5283 1.66079 18.4612 1.56659 18.3675C1.47239 18.2738 1.40499 18.1568 1.3713 18.0286C1.33761 17.9004 1.33886 17.7656 1.37491 17.638L2.26241 14.5417Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.51245 18.9187C9.95301 20.1683 10.6671 21.3048 11.603 22.2464C12.539 23.1879 13.6735 23.9108 14.9246 24.3629C16.1757 24.8151 17.5121 24.9851 18.8373 24.8608C20.1625 24.7365 21.4434 24.3209 22.5875 23.644V23.644L25.7 24.5269C25.8282 24.5627 25.9637 24.564 26.0926 24.5305C26.2215 24.497 26.3391 24.4299 26.4333 24.3362C26.5275 24.2425 26.5949 24.1255 26.6286 23.9973C26.6623 23.8691 26.661 23.7343 26.625 23.6067L25.7374 20.5104C26.5298 19.1873 26.9651 17.6831 27.0013 16.1435C27.0375 14.6039 26.6733 13.081 25.944 11.7226C25.2147 10.3641 24.145 9.21613 22.8386 8.3898C21.5322 7.56347 20.0334 7.08684 18.4875 7.0061"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'spinner'"
      class="spinning"
      width="50"
      height="50"
      viewBox="0 0 50 50"
    >
      <path
        fill="currentColor"
        d="M25,5A20.14,20.14,0,0,1,45,22.88a2.51,2.51,0,0,0,2.49,2.26h0A2.52,2.52,0,0,0,50,22.33a25.14,25.14,0,0,0-50,0,2.52,2.52,0,0,0,2.5,2.81h0A2.51,2.51,0,0,0,5,22.88,20.14,20.14,0,0,1,25,5Z"
      ></path>
    </svg>
    <svg
      v-if="icon === 'automation'"
      width="33"
      height="30"
      viewBox="0 0 33 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4994 20.1207C18.8859 20.1207 20.8207 18.1982 20.8207 15.8267C20.8207 13.4551 18.8859 11.5326 16.4994 11.5326C14.1128 11.5326 12.178 13.4551 12.178 15.8267C12.178 18.1982 14.1128 20.1207 16.4994 20.1207Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.7473 11.5952C22.964 11.9036 23.1538 12.2298 23.3145 12.5703L25.6462 13.8586C25.9373 15.1544 25.9404 16.4977 25.6552 17.7948L23.3145 19.083C23.1538 19.4236 22.964 19.7498 22.7473 20.0582L22.7923 22.7151C21.8041 23.6099 20.6345 24.2841 19.3623 24.6922L17.0666 23.3234C16.6889 23.3503 16.3099 23.3503 15.9322 23.3234L13.6455 24.6832C12.3692 24.2825 11.1958 23.611 10.2065 22.7151L10.2515 20.0671C10.0366 19.7545 9.84694 19.4254 9.68434 19.083L7.35263 17.7948C7.06149 16.499 7.05841 15.1557 7.34363 13.8586L9.68434 12.5703C9.84502 12.2298 10.0348 11.9036 10.2515 11.5952L10.2065 8.93826C11.1947 8.04345 12.3643 7.36931 13.6365 6.9612L15.9322 8.32994C16.3099 8.30309 16.6889 8.30309 17.0666 8.32994L19.3533 6.97014C20.6296 7.37083 21.803 8.04237 22.7923 8.93826L22.7473 11.5952Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.5824 10.1603H31.1142V5.44919"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.45518 15.3794C2.45415 12.6184 3.27727 9.91922 4.8204 7.62325C6.36353 5.32729 8.55733 3.53775 11.1242 2.48104C13.6911 1.42434 16.5157 1.14796 19.2407 1.68687C21.9657 2.22579 24.4686 3.55577 26.4328 5.50856L31.1142 10.1605"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.41635 20.0615H1.88462V24.7727"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30.5436 14.8425C30.5446 17.6034 29.7215 20.3026 28.1784 22.5986C26.6353 24.8946 24.4415 26.6841 21.8746 27.7408C19.3077 28.7975 16.483 29.0739 13.758 28.535C11.033 27.9961 8.53014 26.6661 6.56599 24.7133L1.88458 20.0614"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'down-arrow'"
      width="20"
      height="11"
      viewBox="0 0 20 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.332361 0.328339C0.775509 -0.109447 1.49399 -0.109447 1.93714 0.328339L10 8.29362L18.0629 0.328339C18.506 -0.109447 19.2245 -0.109447 19.6676 0.328339C20.1108 0.766124 20.1108 1.47591 19.6676 1.9137L10.8024 10.6717C10.3592 11.1094 9.64076 11.1094 9.19761 10.6717L0.332361 1.9137C-0.110787 1.47591 -0.110787 0.766124 0.332361 0.328339Z"
        fill="currentColor"
      />
    </svg>
    <svg
      v-if="icon === 'up-arrow'"
      width="20"
      height="11"
      viewBox="0 0 20 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.6676 10.6717C19.2245 11.1094 18.506 11.1094 18.0629 10.6717L10 2.70638L1.93714 10.6717C1.49399 11.1094 0.775509 11.1094 0.33236 10.6717C-0.110788 10.2339 -0.110788 9.52409 0.33236 9.0863L9.19761 0.328339C9.64076 -0.109446 10.3592 -0.109446 10.8024 0.328339L19.6676 9.0863C20.1108 9.52409 20.1108 10.2339 19.6676 10.6717Z"
        fill="currentColor"
      />
    </svg>
    <svg
      v-if="icon === 'empty-circle'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z"
        stroke="#212121"
      />
    </svg>
  </div>
</template>
<script>
export default {
  props: ["icon"],
};
</script>
<style scoped>
@media screen {
  .round-button-with-icon {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  svg:hover {
    filter: drop-shadow(0px 4px 4px var(--shadow));
  }
  svg {
    max-height: 60%;
    max-width: 60%;
    display: block;
    margin: 0 auto;
  }
  .spinning {
    animation-name: spin;
    animation-duration: 1s;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @media (min-width: 800px) {
    .round-button-with-icon {
      width: 25px;
      height: 25px;
      min-width: 25px;
      min-height: 25px;
    }
  }
  @media (min-width: 1200px) {
  }
}
</style>
